<template>
    <span>
        {{ getStringByKey({ model, languagekey }) }}
    </span>
</template>

<script>


export default {
    props: ['model', 'languagekey'],
    methods: {
        getStringByKey({ model, languagekey }) {
            return model.localizedStrings[languagekey] || {};
        }
    }
};
</script>
